import React from 'react';
import { onToast, ToastPayload } from '../lib/toast';

type T = Required<ToastPayload>;

export default function StatusBar() {
  const [last, setLast] = React.useState<T|null>(null);

  React.useEffect(() => {
    return onToast((t) => {
      setLast(t);
      const timer = setTimeout(() => setLast(null), Math.min(3000, t.duration));
      return () => clearTimeout(timer);
    });
  }, []);

  if (!last) return null;
  const base = last.variant === 'success' ? 'bg-green-600' : last.variant === 'error' ? 'bg-red-600' : last.variant === 'warning' ? 'bg-yellow-600' : 'bg-blue-600';
  return (
    <div className={`${base} text-white text-sm px-3 py-2`}
      role="status"
      data-testid="statusbar">
      <strong>{last.title}</strong>
      {last.description ? <span className="ml-2 opacity-90">{last.description}</span> : null}
    </div>
  );
}


